module.exports = __webpack_public_path__ + "img/Button_Minus.9d7f827e.png";